import { useMutation } from "react-query";
import { useHeaders } from "hooks/api/useHeaders";
import { updateFormFieldsReq } from "api";

export const useFormFields = () => {
    const headers = useHeaders();

    return useMutation(
        (params: { materialSpecId: number; materialId?: number; fields: { [key: string]: string | number } }) =>
            updateFormFieldsReq(headers, params.fields, params.materialSpecId, params.materialId)
    );
};
